import { SET_OVERVIEW_FILTERS, SET_OVERVIEW_FILTERS_FOCUS } from '../types';
import store from '../store';

export const setOverviewFilters = (filters) => ({
  type: SET_OVERVIEW_FILTERS,
  payload: filters,
  userConfig: store.getState().userReducer.configuration,
});

export const setOverviewFiltersFocus = (field) => ({
  type: SET_OVERVIEW_FILTERS_FOCUS,
  payload: field,
});

export default setOverviewFilters;
